"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { NITRO_ENABLED } from "@/components/nitro/config";

declare global {
  interface Window {
    __cmp?: (command: string) => void;
  }
}

/** Nitro CMP adds its own GDPR consent-management button in EU regions.
 * A CCPA opt-out is injected in eligible US regions.
 * These are hooks, not independently functioning buttons.
 */
export default function PrivacyChoices({ inPolicy = false }: { inPolicy?: boolean }) {
  const pathname = usePathname();
  useEffect(() => {
    if (!NITRO_ENABLED || inPolicy) return;
    const update = () => { try { window.__cmp?.("addConsentLink"); } catch {} };
    update();
    document.addEventListener("nitroAds.loaded", update);
    return () => document.removeEventListener("nitroAds.loaded", update);
  }, [pathname, inPolicy]);

  if (!NITRO_ENABLED) return null;
  return (
    <div style={{ display: "grid", gap: 10 }} aria-label="Advertising privacy choices">
      {!inPolicy && <div id="ncmp-consent-link" />}
      <span data-ccpa-link="1" />
    </div>
  );
}
